<template>
  <div>
    <div id="footer">
      <div class="container">
        <div class="col-xs-12 col-sm-hidden col-md-4">
          <br>
          <div class="logo_title">
            <img src="@/assets/img/logo.png" alt="logo图" style="height: 100px;width: auto; margin-bottom: 10%">

            <!--            <img src="@/assets/img/code1.png" alt="logo图" style="height: 120px;width: auto; margin-bottom: 10%">-->
            <div>
              <p style="font-size: 20px;">{{ this.$dt('Footer.companyAddress') }}</p>
              <p style="font-size: 15px">{{ this.$dt('Footer.fullAddress') }}</p>
            </div>
            <div style="margin-top: 10%">
              <p style="font-size: 20px;">{{ this.$dt('Footer.phone') }}</p>
              <p style="font-size: 15px">{{ this.$dt('Footer.num1') }}</p>
              <p style="font-size: 15px">{{ this.$dt('Footer.num2') }}</p>
            </div>
            <div style="margin-top: 10%">
              <p style="font-size: 20px;">{{ this.$dt('Footer.email') }}</p>
              <p style="font-size: 15px">infor@sinochrome.cn</p>
            </div>
            <div style="margin-top: 22%; ">
              <p>{{ this.$dt('Footer.allRightsReserveds') }}&copy; 2018 - {{ new Date().getFullYear() }}
                {{ this.$dt('Footer.name') }} </p>
              <a style="white-space: nowrap; color: #cbcbcb" href="https://beian.miit.gov.cn">沪ICP备11005475号-5</a>
            </div>
            <div style="margin-top: 15%; ">
              <a style="white-space: nowrap; color: #fff;font-size: 20px;"
                 href="http://edatope.sinochrome.com.cn/">{{ this.$dt('Footer.logoName') }}</a>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-hidden col-md-8" id="products" style="margin-top: 5%">
          <div class="col-xs-12 col-sm-hidden col-md-3">
            <div class="navigation-name">{{ this.$dt('Footer.instrument') }}</div>
            <div v-for="item in products.instrument" class="product-name">
              <router-link style="color:#ffffff;" :to="'/product/instrumentPage/'+item.id">{{ item.name }}</router-link>
            </div>
          </div>
          <div class="col-xs-12 col-sm-hidden col-md-3">
            <div class="navigation-name">{{ this.$dt('Footer.reagent') }}</div>
            <div v-for="item in products.reagent" class="product-name">
              <router-link style="color:#ffffff;" :to="'/product/reagentPage/'+item.id"> {{ item.name }}</router-link>
            </div>
          </div>
          <div class="col-xs-12 col-sm-hidden col-md-3">
            <div class="navigation-name">{{ this.$dt('Footer.software') }}</div>
            <div v-for="item in products.software" class="product-name">
              <router-link style="color:#ffffff;" :to="'/product/softwarePage/'+item.id">{{ item.name }}</router-link>
            </div>
          </div>
          <div class="col-xs-12 col-sm-hidden col-md-3">
            <div class="navigation-name">{{ this.$dt('Footer.aboutUs') }}</div>
            <div class="product-name">
              <router-link style="color:#ffffff;" :to="'/contactus'">{{ this.$dt('Footer.contactUs') }}</router-link>
            </div>
            <div class="product-name">
              <router-link style="color:#ffffff;" :to="'/recruitment'">{{
                  this.$dt('Footer.recruitment')
                }}
              </router-link>
            </div>
            <div class="product-name">
              <router-link style="color:#ffffff;" :to="'/aboutUs'">{{ this.$dt('Footer.aboutUs') }}</router-link>
            </div>
          </div>
          <!--          <button class="btn btn-default btn-sm">
                      <router-link :to="'contactus'">联系我们</router-link>
                    </button>-->
          <div style="margin-top: 350px; margin-left: 520px; display: flex">
            <div style="text-align: center;margin-right: 20px;width: 120px;">
              <img src="@/assets/img/微信公众号.jpg" alt="logo图" style="height: 120px;  margin-bottom: 15px;">
              <div class="img-name">{{ this.$dt('Footer.ProductOrdering') }}</div>
            </div>
            <div style="text-align: center;margin-right: 20px;width: 120px; ">
              <img src="@/assets/img/code.jpg" alt="logo图" style="height: 120px; margin-bottom: 15px;">
              <div class="img-name">{{ this.$dt('Footer.CorporateWeChatAccount') }}</div>
            </div>
          </div>
        </div>


        <div class="col-xs-12 col-sm-hidden col-md-12" id="products" style="margin-top: 5%">

        </div>
      </div>

    </div>
  </div>
</template>
<script>
import { getAction } from '../api/manage'

export default {
  name: 'Footer',
  data () {
    return {
      lang: 'zh',
      products: {
        instrument: [],
        reagent: [],
        software: []
      }
    }
  },
  created () {
    // 从localStorage获取语言设置，如果没有则默认为中文
    const lang = localStorage.getItem('lang') || 'zh'
    this.loadInstrumentNav()
    this.loadSoftwareNav()
    this.loadReagentNav()
    console.log(this.products)
  },
  methods: {

    // 加载仪器导航
    loadInstrumentNav () {
      // 查询条件
      let queryParam = {
        currentPage: 1,
        pageSize: -1,
        search: {
          isNav: '1',
          name: '',
          remark: ''
        }
      }
      getAction('/instrument/list', queryParam).then((res) => {
        this.products.instrument = res.data.data.rows
      })

    },
    // 加载试剂导航
    loadSoftwareNav () {
      // 查询条件
      let queryParam = {
        currentPage: 1,
        pageSize: -1,
        search: {
          id: '',
        }
      }
      getAction('/reagent/list', queryParam).then((res) => {
        this.products.reagent = res.data.data.rows
      })

    },
    // 加载软件导航
    loadReagentNav () {
      // 查询条件
      let queryParam = {
        currentPage: 1,
        pageSize: -1,
        search: {
          isNav: '1',
        }
      }
      getAction('/software/list', queryParam).then((res) => {
        this.products.software = res.data.data.rows
      })
    },

  }
}
</script>
<style scoped>
#footer {
  font-size: 15px;
  width: 100%;
  height: 770px;
  color: #ffffff;
  background-color: #448ef7;
  /*  background: #ad997a;*/
  overflow: hidden;
}

.logo {
  margin-top: 20px;
  width: 400px;
}

.logo img {
  float: right;
}

.logo_title {
  margin-top: 20px;
  width: 400px;
  line-height: 16px;
}

#footer table {
  margin-top: 30px;
  width: 510px;
}

#footer table th {
  width: 170px;
  font-size: 28px;
  padding-bottom: 30px;
}

#footer table td {
  font-size: 18px;
  padding: 5px;

}

.copy {
  color: #000000;
  font-size: 14px;
  margin: auto;
  text-align: center;
}

.navigation-name {
  font-size: 19px;
  margin-bottom: 50px;
}

.product-name {
  margin-top: 20px;
  font-size: 14px
}

.img-name {
  font-size: 19px;
  margin-bottom: 25px;
}

@media screen and (max-width: 997px) {
  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }

  .logo_title {
    padding-left: 0;
    margin-top: 0;
    width: 100%;
    line-height: 16px;
  }

  #products {
    display: none;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue